import { render, staticRenderFns } from "./HomePageHeroSimple.vue?vue&type=template&id=38bb3876&scoped=true&"
import script from "./HomePageHeroSimple.vue?vue&type=script&lang=js&"
export * from "./HomePageHeroSimple.vue?vue&type=script&lang=js&"
import style0 from "./HomePageHeroSimple.vue?vue&type=style&index=0&id=38bb3876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bb3876",
  null
  
)

export default component.exports